import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const CategoriasAtm = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_CATEGORIA_CAJERO, GET_PARAMETRO_GENERAL } = data;
    const arrayAux = GET_CATEGORIA_CAJERO.filter(d => d.Checked);
    const acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

    if (!data.GET_PARAMETRO_GENERAL) {
        return null;
    }

    if (!data.GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
        return null
    }


    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Categor" + acentoLetraIminuscula + "as cajero"}</label>

                {GET_CATEGORIA_CAJERO.map((item) => {
                    const referencia = `GCC-${item.Id}`;
                    if ( (item.AdministradoraId == 1 && item.Activo) || ( item.AdministradoraId == 1 && item.noDisponible) ){
                        return (
                            <CheckDefecto       
                                key={item.Id}
                                nombre={item.Descripcion}
                                check={item.Checked}
                                activo={item.Activo}
                                referencia={referencia}
                                selectCheckBox={() => selectCheckBox("GET_CATEGORIA_CAJERO", item.Id)} />
                        )
                    }
                })}

                <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"CategoriaCajeroDefaultId"}
                    valorCombo={data.CategoriaCajeroDefaultId}
                    valorChecked={data.CategoriaCajeroDefaultInterfaz}
                    selectCombo={(value) => selectCombo("CategoriaCajeroDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("CategoriaCajeroDefaultInterfaz", value)}
                />

                {(data.ERROR_PRODUCT["seleccionoCategoria"] == false && arrayAux.length===0 ) &&
                    <label className="error">{"Debe seleccionar al menos una categoria."}</label>}
            </div>
        </div>
    );
}

export default CategoriasAtm;